import {NotificacaoInfoRow,} from '@components/usuario/notificacoes/NotificacaoInformacao.tsx';
import {__usuarios_endpoints} from '@components/usuario/endpoints/__usuarios_endpoints.ts';
import {IPagination} from '@localization/siteMap/siteMapInterfaces.ts';
import {INotificacao} from '@models/conta/notificacao.ts';
import {DefaultPageProps} from '@models/DefaultProps.ts';
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import {DefaultContainer} from '@shared/DefaultContainer.tsx';
import React, {useEffect, useState} from 'react';
import {useApi} from "@contexts/hooks/api/useApi.ts";

export interface NotificacoesPageProps extends DefaultPageProps {
}


export function NotificacoesPage(props: NotificacoesPageProps) {
    const {Get} = useApi();
    const {GetMinhasNotificacoes} = __usuarios_endpoints;

    const [notificacoes, setNotificacoes] = useState<INotificacao[]>([]);
    const [pagination, setPagination] = useState<IPagination>({page: 1, pageSize: 10});
    useEffect(() => {
        if (pagination.page <= 0) {
            setPagination({...pagination, page: 1});
            return;
        }
        setPagination(prev => ({...prev, loading: true}));
        Get(GetMinhasNotificacoes({excluirLidos: false}, pagination)).then(x => {
            if (x.hasData) {
                setNotificacoes(x.items);
                setPagination(prev => ({...prev, ...x.pagination}));
            }
        }).finally(() => {
            setPagination(prev => ({...prev, loading: false, ignoreCache: false}))
        })

    }, [pagination.page]);


    return (<DefaultContainer pageProps={{pagination, setPagination}} {...props}
                              size={'large'}
                              component={Paper}
                              titulo={'Notificações'}>

        <TableContainer>
            <Table size={'small'} stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell>Id</TableCell>
                        <TableCell>Mensagem</TableCell>
                        <TableCell>Data</TableCell>
                        <TableCell>Tipo</TableCell>
                        <TableCell>Mais</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {notificacoes.map((e) => {
                        return <NotificacaoInfoRow value={e} key={e.id}/>;
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    </DefaultContainer>);
}